<template>
  <!-- chekcbox if has option of error message (has to be nested in div) -->
  <div v-if="input.validationBox">
    <label
      :for="input.label"
      :class="{
        [$style.baseCheckbox]: true,
        [$style.halfWidth]: input.width === 'half',
        [$style.marginTop]: input.margin === 'top',
        [$style.isDisabled]: input.disabled,
        [$style.land]: el.is.land,
        [$style.port]: el.is.port,
        [$style.phone]: el.is.phone
      }"
      :style="{ marginBottom: input.validationBox && '7px' }"
    >
      <!-- hidden checkbox input -->
      <input
        :disabled="disabled"
        hidden
        type="checkbox"
        v-model="selectedValue"
        :id="input.label"
        @change="onChange"
        :class="$style.input"
      />

      <!-- custom checkbox -->
      <span
        :class="{
          [$style.inputCustom]: true,
          [$style.inputCustomNewDesign]: isNewDesign,
          [$style.checked]: checked && !input.disabled,
          [$style.checkedNewDesign]: checked && !input.disabled && isNewDesign,
          [$style.invalid]: isInvalid
        }"
      >
        <img
          v-if="checked && !input.disabled"
          :src="getCheckedIcon"
          alt="checked sign icon"
        />
      </span>
      <!-- text -->
      <span :class="$style.labelText"> {{ input.label }} </span>
    </label>
    <!-- error message -->
    <p
      :class="$style.errorMessage"
      v-if="isInvalid && input.validations.message"
    >
      {{ input.validations.message }}
    </p>
  </div>
  <!-- chekcbox if no error message -->
  <label
    v-else
    :for="input.label"
    :class="{
      [$style.baseCheckbox]: true,
      [$style.halfWidth]: input.width === 'half',
      [$style.marginTop]: input.margin === 'top',
      [$style.isDisabled]: input.disabled,
      [$style.land]: el.is.land,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone
    }"
  >
    <!-- hidden checkbox input -->
    <input
      :disabled="disabled"
      hidden
      type="checkbox"
      v-model="selectedValue"
      :id="input.label"
      @change="onChange"
      :class="$style.input"
    />

    <!-- custom checkbox -->
    <span
      :class="{
        [$style.inputCustom]: true,
        [$style.inputCustomNewDesign]: isNewDesign,
        [$style.checked]: checked && !input.disabled,
        [$style.checkedNewDesign]: checked && !input.disabled && isNewDesign,
        [$style.invalid]: isInvalid
      }"
    >
      <img
        v-if="checked && !input.disabled"
        :src="getCheckedIcon"
        alt="checked sign icon"
      />
    </span>
    <!-- text -->
    <span :class="$style.labelText"> {{ input.label }} </span>
  </label>
</template>

<script>
import store from '@/store'

export default {
  props: {
    input: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedValue: '',
      isInvalid: false,
      disabled: false
    }
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    // note: new design
    getCheckedIcon() {
      if (this.isNewDesign) {
        return require('../../assets/images/checked-sign_new.svg')
      } else {
        return require('../../assets/images/checked-sign.svg')
      }
    },
    vuexInputValidate() {
      return store.state.inputValidate
    },
    checked() {
      return this.selectedValue
    },
    el() {
      return store.state.el
    },
    inputValue() {
      return this.input.selectedValue
    }
  },
  methods: {
    onChange() {
      if (this.input.disabled) {
        return
      }
      const data = {
        slideName: this.input.slideName,
        formName: this.input.formName,
        value: this.selectedValue,
        name: this.input.name
      }
      if (this.input.validations.required) {
        data.isInvalid = !this.selectedValue
        this.isInvalid = !this.selectedValue
      }
      this.$emit('onCheck', data)
    }
  },
  created() {
    this.selectedValue = this.input.selectedValue
  },
  watch: {
    inputValue(newValue, oldValue) {
      this.selectedValue = newValue
    },
    vuexInputValidate() {
      if (this.vuexInputValidate && this.input.validations.required) {
        this.isInvalid = !this.selectedValue
      }
    }
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';

.baseCheckbox {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 15px;
  width: 100%;
  align-items: center;
  cursor: pointer;
}

.isDisabled {
  cursor: not-allowed;

  .labelText {
    user-select: none;
    color: $color_font_1;
  }
  .inputCustom {
    background-color: $color_grey_1;
    user-select: none;
  }
  input {
    user-select: none;
  }
}

.halfWidth {
  width: 380px;
}

.inputCustom {
  background-color: $color-bg-light;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  border: 2px solid $color_grey_3;
  margin-right: 20px;
}

// note: new design
.inputCustomNewDesign {
  border: 2px solid $color_border_new;
}

.marginTop {
  align-items: flex-start;
  .inputCustom {
    margin-top: -5px;
  }
}

.checked {
  border: 2px solid $color_green_2;
}

// note: new design
.checkedNewDesign {
  border: 2px solid $color_border_dark_new;
}

.labelText {
  display: inline-block;
  color: $color_font_3;
  text-align: left;
  width: 90%;
  line-height: 1.2;
  font-size: 16px;
}

.invalid {
  border: 2px solid $color_error;
}

.errorMessage {
  display: block;
  color: white;
  line-height: 1.2;
  font-size: 13px;
  background-color: $color_error;
  padding: 5px 0;
  text-align: left;
  padding-left: 44px;
}

// note: LAND
.land {
  &.halfWidth {
    width: 49%;
    .inputCustom {
      margin-right: 4.08%;
      margin-top: -22px;
    }
  }
}

// note: PORT
.port {
  &.halfWidth {
    width: 49%;
    .inputCustom {
      margin-top: 0px;
    }
  }
}

// note: phone
.phone {
  &.halfWidth {
    width: 100%;
    .inputCustom {
      margin-right: 20px;
    }
  }
  .labelText {
    font-size: 13px;
  }
}
</style>
